import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import requestErrorTreatment from "@shared/utils/requestErrorTreatment";
import { tiledeskStatusQueryKey } from "@modules/tiledesk/services/queries/getTiledeskStatus";
import { TiledeskStatus } from "@modules/tiledesk/types";
import { disableTiledeskService } from "./service";

export function useDisableTiledeskMutation(agreementId: string) {
  const { open } = useNotification();
  const translate = useTranslate();
  const queryClient = useQueryClient();

  return useMutation<TiledeskStatus, ApiError, void>({
    mutationFn: () => disableTiledeskService(agreementId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: tiledeskStatusQueryKey(agreementId),
      });
      open?.({
        type: "success",
        message: translate("tiledesk.success.disable"),
      });
    },
    onError: (error: ApiError) => {
      requestErrorTreatment(error, open);
    },
  });
}
